import { Button } from "@mui/material";
import Modal from "../../Components/Modal";
import theme from "../../Theme/Theme";
import { Vocabulary } from "../../Utils/Vocabulary";
type DeleteOrderStatusProps = {
  openDeleteModal: boolean;
  setOpenDeleteModal: (openDeleteModal: boolean) => void;
  handleDelete: () => void;
};

export default function DeleteOrderStatus(props: DeleteOrderStatusProps) {
  const { openDeleteModal, setOpenDeleteModal, handleDelete } = props;
  return (
    <Modal
      open={openDeleteModal}
      onClose={() => setOpenDeleteModal(false)}
      title=""
    >
      <div style={{ textAlign: "center" }}>
        <p style={{ fontSize: "20px" }}>{Vocabulary.statusOrderDevice}</p>
        <Button
          variant="contained"
          type="submit"
          style={{ margin: 20, color: theme.palette.whiteColor?.main }}
          size="large"
          color="primary"
          onClick={() => handleDelete()}
        >
          {Vocabulary.yes}
        </Button>
        <Button
          variant="contained"
          type="submit"
          style={{
            margin: 20,
            color: theme.palette.whiteColor?.main,
            backgroundColor: theme.palette.errorColor?.main,
          }}
          size="large"
          onClick={() => setOpenDeleteModal(false)}
        >
          {Vocabulary.no}
        </Button>
      </div>
    </Modal>
  );
}
